module.exports = __webpack_public_path__ + "img/aps.cb4d13a2.png";